import { Button } from '@mui/material'
import { useHistoryCustomBack } from 'weblite-router'
import { goToAuthSignin } from '$logic/router'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { t } from '$i18n'

export function AuthStartingPage() {
  const isDesktop = useIsDesktopSize()

  useHistoryCustomBack(() => 'closeApp', [])

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'end',
        justifyContent: 'center',
        padding: '0 16px 32px',
        maxWidth: isDesktop ? '368px' : 'unset',
      }}
    >
      <Button
        sx={{ backgroundColor: 'primary500' }}
        variant="contained"
        fullWidth
        onClick={goToAuthSignin}
      >
        {t('auth.startingPage')}
      </Button>
    </div>
  )
}
